import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { defaultPostBakingWasteWoodInputTrasactionDetail } from "../../constance/dataTypes";
import { GET, POST } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../common/ErrorMessage";
import * as _ from "lodash";
import { formatComma } from "../../utils/stringFormat";
import { Toast } from "../../utils/Toast";
import { FONT_NORMAL_ANDROID, ALIGN_CENTER_ANDROID, FONT_MEDIUM_ANDROID, FONT_LARGE_ANDROID } from '../../constance/printers';
import moment from "moment";
import WasteWoodSizeAmountMapList from "./WasteWoodSizeAmountMapList";
import ConfirmModal from "../common/ConfirmModal";
import Title from "antd/es/typography/Title";
import { Spin, Button, Space } from "antd";
import { CheckOutlined, PrinterFilled, PlusOutlined, EditFilled } from "@ant-design/icons";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR, GREEN, Yellow_COLOR } from "../../constance/color";
import dayjs from "dayjs";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";


export default function WoodSummary(props) {
  const {
    transaction,
    transactionDetail,
    setTransactionDetail,
    onSearchWasteWood,
    onAdd,
    onEdit,
    onFinish,
  } = props;

  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [openDoneCheckModal, setOpenDoneCheckModal] = React.useState(false);
  const hasGroupDate = _.get(transactionDetail, 'post_baking_group_date', null)
  const isDone = _.get(transactionDetail, 'is_done', true)

  const handleAddWood = () => {
    if (!transactionDetail.post_baking_group_date) {
      onSearchWasteWood()
    } else {
      onAdd(transactionDetail.post_baking_group_date, transactionDetail.ovens)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${transaction}/`);
      setTransactionDetail({
        ...defaultPostBakingWasteWoodInputTrasactionDetail,
        ...response.data
      });

    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  const handlePrint = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await POST(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${transaction}/print/`)
      doPrintAndriod({ ...transactionDetail, ...response.data })
      Toast.success(`${t('print')} ${t('success')}`)
    } catch (error) {
      setErrorMessages(_.get(error, 'errorMessages', '') ? error.errorMessages : new String(error))
    } finally {
      setLoading(false);
    }
  }

  const doPrintAndriod = (detail) => {
    if (window.JSInterface) {
      let datas = []

      datas.push(ALIGN_CENTER_ANDROID)
      datas.push(FONT_LARGE_ANDROID)

      // title
      datas.push(_.get(detail, 'barcode', '-'))
      let titleRender = "รับเข้าไม้เสีย "
      datas.push(titleRender)

      // group date
      datas.push(FONT_MEDIUM_ANDROID)
      let groupDateRender = "วันที่ยุบกอง "
      const groupDate = dayjs(_.get(detail, 'post_baking_group_date', ''), DATE_FORMAT)
      if (groupDate.isValid()) {
        groupDateRender += groupDate.format(HUMAN_DATE_FORMAT)
      } else {
        groupDateRender += '-'
      }
      datas.push(groupDateRender)

      // input date
      let inputDateRender = "วันที่รับคืน "
      const inputDate = dayjs(_.get(detail, 'input_date', ''), DATE_FORMAT)
      if (inputDate.isValid()) {
        inputDateRender += inputDate.format(HUMAN_DATE_FORMAT)
      } else {
        inputDateRender += '-'
      }

      datas.push(inputDateRender)
      datas.push("")
      datas.push(FONT_NORMAL_ANDROID)

      // wood list
      _.get(detail, 'wood_size_amount_map_list', []).filter(ws => _.get(ws, 'amount', 0) > 0).map(ws => {
        datas.push(`${ws.wood_code} : ${formatComma(ws.amount)}(${formatComma(ws.volume)}) ท่อน`)
      })

      datas.push("")
      datas.push(`รวม ${formatComma(_.get(detail, 'sum_amount', 0))} ท่อน ${formatComma(_.get(detail, 'sum_volume', 0))} ฟุต`)

      datas.push("")
      datas.push(FONT_MEDIUM_ANDROID)

      // print render
      let printRender = "พิมพ์วันที่ "
      const printDate = dayjs(_.get(detail, 'print_datetime', ''))
      if (printDate.isValid()) {
        printRender += printDate.format('DD/MM/YYYY HH:mm')
      } else {
        printRender += '-'
      }
      datas.push(printRender)
      datas.push(`โดย ${_.get(detail, 'print_user_name', '-')}`)


      window.JSInterface.printAndroid(datas.join('\r\n'))
    }
  }

  const handleDoneCheck = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      await POST(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_DONE_CHECK}`,
        { post_baking_group_date: transactionDetail.post_baking_group_date }
      );
      fetchData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (transaction) {
      fetchData();
    }
  }, [transaction])

  return (
    <div style={{ marginTop: '1rem' }}>
      <Title level={5}>{t('barcodes.barcode_id')}: {transactionDetail.barcode}</Title>
      {transactionDetail.post_baking_group_date ? (
        <Title level={5}>
          <div>
            {t('post_baking_waste_wood_count.group_date')}&nbsp;
            {dayjs(transactionDetail.post_baking_group_date, DATE_FORMAT).format(HUMAN_DATE_FORMAT)}
          </div>
          {transactionDetail.input_date && (
            <div>
              {t('post_baking_waste_wood_input.input_date')}&nbsp;
              {dayjs(transactionDetail.input_date, DATE_FORMAT).format(HUMAN_DATE_FORMAT)}
            </div>
          )}
        </Title>
      ) : null}
      <Spin spinning={loading} tip={t('loading')} fullscreen />
      <ErrorMessage message={errorMessages} />

      <WasteWoodSizeAmountMapList
        dataList={transactionDetail.wood_size_amount_map_list}
        readOnly={_.get(transactionDetail, 'interfaced', false)}
        onEdit={onEdit}
        fetchData={fetchData} />

      {hasGroupDate && (
        <div>
          {isDone ? (
            <span><CheckOutlined style={{ color: GREEN }} /> {t('post_baking_waste_wood_input.done_check')}</span>
          ) : (
            <ColorButton
              type='primary'
              override={Yellow_COLOR}
              icon={<EditFilled />}
              onClick={() => setOpenDoneCheckModal(true)} >{t('post_baking_waste_wood_input.done_check')}</ColorButton>
          )}
        </div>
      )}

      <div style={{ marginTop: '2rem' }}>
        <Space>
          {(!hasGroupDate || !isDone) &&
            <ColorButton type='primary' override={GREEN} icon={<PlusOutlined />} onClick={handleAddWood} >{t('add')}</ColorButton>}
          <ColorButton
            type='primary' override={BLUE_COLOR} icon={<PrinterFilled />}
            disabled={!transactionDetail.wood_size_amount_map_list.length}
            onClick={() => handlePrint()} >{t('print')}</ColorButton>
          <Button variant="filled" color="default" onClick={onFinish} >{t('finish')}</Button>
        </Space>
      </div>

      <ConfirmModal
        open={openDoneCheckModal}
        onClose={() => setOpenDoneCheckModal(false)}
        title={t('post_baking_waste_wood_input.done_check')}
        content={`${t('workflows.confirmation_content')}: [${t('post_baking_waste_wood_input.done_check')}]?`}
        onConfirm={handleDoneCheck} />
    </div>
  )
}


WoodSummary.propTypes = {
  transaction: PropTypes.string,
  onSearchWasteWood: PropTypes.func,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onFinish: PropTypes.func,
}

WoodSummary.defaultProps = {
  transaction: '',
  onSearchWasteWood: () => null,
  onAdd: () => null,
  onEdit: () => null,
  onFinish: () => null,
}